import React, { useEffect, useState } from "react";
// import Sidebar from "../../../layouts/sidebar";
// import Sidebar from "../../layouts/sidebar";
import Headers from "../layouts/header";
import "react-datetime/css/react-datetime.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
// import useAxiosFile from "../../../actions/useaxios";
// import useAxiosFile from "../../actions/useaxios";
// import config from "../../../actions/config";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { DecryptData, EncryptData, isEmpty } from "../../../actions/common";
// import {  EncryptData, isEmpty } from "../../actions/common";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "react-bootstrap";
import Sidebar from "../layouts/sidebar";
import useAxiosFile from "../actions/useaxios";
import { DateTimeForm, isEmpty } from "../actions/common";

function Sitemap() {
  const { toggle } = useSelector((state) => state.admin_panel.User);

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();
  const { from, _id, id, sitemapName } = useParams()
  const [Datas, SetDatas] = useState([]);
  const [Search, SetSearch] = useState("");
  const [city, SetCity] = useState("");
  const [ValidateError, SetValidateError] = useState("");


  //sitemap
  const [Sitemap, SetSitemap] = useState({
    from: "",
    url: ""
  })




  var { pathname } = useLocation()
  pathname = pathname.split('/')[1]
  console.log("pathname======", pathname)
  // sitemap-edit


  useEffect(() => {
    if (pathname == "sitemap" || pathname == "sitemap-edit" || pathname == "sitemap-all") GetLocations();
  }, [pathname]);

  const GetLocations = async () => {

    var resp = await axiosFile.SitemapAction({ sitemapName, from, action: pathname, Search: Search, _id });
    console.log("dasdasdsadsa", resp);
    if (_id) {
      SetSitemap({
        url: resp?.data?.[0]?.location,
        from: resp?.data?.[0]?.from,
      })
    }
    else if (from) SetDatas(resp?.data?.[0]?.sitemap)
    else SetDatas(resp?.data);
    // SetDatas(resp?.data)
  };

  async function _showhide(params, showhome) {
    let resp = await axiosFile.CityAction({ from: 'admin', action: 'showhide', showhome: showhome, _id: params });
    console.log("resp.success ", resp.success, resp?.msg);

    if (resp.success == "success") {
      toast.success(`now will ${showhome ? 'Hide' : 'Show'} in Home page`);
      GetLocations();
      return
    }
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }

  async function _delete(params, showhome) {
    let resp = await axiosFile.SitemapAction({ from: 'admin', action: 'delete', _id: params });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Deleted from Documnet Successfully`);
      GetLocations();
      return
    }
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _add(params, showhome) {
    if (isEmpty(Sitemap?.from)) {
      SetValidateError({
        from: "From required"
      })
      toast.error("From required");
      return false
    }
    if (isEmpty(Sitemap?.url)) {
      SetValidateError({
        url: "Location url required"
      })
      toast.error("Location url required");
      return false
    }
  }
  async function _add(params, showhome) {
    if (isEmpty(Sitemap?.from)) {
      SetValidateError({
        from: "From required"
      })
      toast.error("From required");
      return false
    }
    if (isEmpty(Sitemap?.url)) {
      SetValidateError({
        url: "Location url required"
      })
      toast.error("Location url required");
      return false
    }

    let resp = await axiosFile.SitemapAction({ from: 'admin', action: 'sitemap-add', Sitemap });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Added Sitemap Successfully`);
      navigate('/sitemap')
      return
    }
    console.log("respresprespresp", resp);

    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }
  async function _edit(params, showhome) {
    if (isEmpty(Sitemap?.from)) {
      SetValidateError({
        from: "From required"
      })
      toast.error("From required");
      return false
    }
    if (isEmpty(Sitemap?.url)) {
      SetValidateError({
        url: "Location url required"
      })
      toast.error("Location url required");
      return false
    }


    let resp = await axiosFile.SitemapAction({ from: 'admin', action: "edit", Sitemap, _id });
    console.log("resp.success ", resp.success, resp?.msg);
    if (resp.success == "success") {
      toast.success(`Edited from Documnet Successfully`);
      navigate('/sitemap')
      // SetCity("")
      // GetLocations();
      return
    }
    SetValidateError(resp.error)
    return toast.error(resp?.msg ? resp?.msg : "Something Went Wrong");

  }


  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });
  const pagination1 = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });
  const columns_sitemap = [

    {
      dataField: "from",
      text: "From",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{cell}</p>
        </>
      )
    },
    {
      dataField: "location",
      text: "Location",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{cell}</p>
        </>
      )
    },
    {
      dataField: "updatedAt",
      text: "Last Modified",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{DateTimeForm(cell)}</p>
        </>
      )
    },
    {
      dataField: "from",
      text: "Show",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div onClick={() => {
            let data = row.location.split('/')
            let url = data[data.length - 1]
            url = url.split('.xml')[0]
            console.log("url", data, row.location, data, data[data.length - 1], data.length)
            navigate(`/sitemap-all/${(cell)}/${url}`)
          }
          }>

            <p>Show</p></div>
        </>
      )
    },
    // {
    //   dataField: "_id",
    //   text: "Edit",
    //   sort: true,
    //   formatter: (cell, row, rowindex) => (
    //     <>
    //       <div onClick={()=>navigate(`/sitemap-edit/${(cell)}`)}>

    //       <p>Edit</p></div>
    //     </>
    //   )
    // },
    // {
    //   dataField: "_id",
    //   text: "Delete",
    //   sort: true,
    //   formatter: (cell, row, rowindex) => (
    //     <>
    //       <div onClick={()=>_delete(cell)}>

    //       <p>Delete</p></div>
    //     </>
    //   )
    // }
  ];


  const columns = [

    {
      dataField: "url",
      text: "URL",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log('cellcell', cell, row)}
          <p>{cell}</p>
        </>
      )
    },
    {
      dataField: "priority",
      text: "PRIORITY",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p>{cell}</p>
        </>
      )
    },
    {
      dataField: "changefreq",
      text: "Change Frequency",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div>

            <p>{cell}</p></div>
        </>
      )
    },





    {
      dataField: "_id",
      text: "Edit",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div onClick={() => navigate(`/sitemap/${row.from}/edit/${cell}`)}>

            <p>{'Edit'}</p>
          </div>
        </>
      )
    },
    {
      dataField: "_id",
      text: "Delete",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <div onClick={() => _delete(cell)}>

            <p>{'Delete'}</p>
          </div>
        </>
      )
    },




  ];


  return (
    <>
      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title mb-0">Sitemap</p>
            </div>
            {pathname == "sitemap" ?
              <div className="rightside just_end ">
                <button
                  type="button"
                  className="blue_btn add_deliveryprsn dp_btn_hover"
                  onClick={() => navigate(`/sitemap-add`)}
                >
                  Add Sitemap
                </button>

              </div> : <></>}
            {pathname == "city" ?
              <div className="rightside just_end ">
                <button
                  type="button"
                  className="blue_btn add_deliveryprsn dp_btn_hover"
                  onClick={() => navigate(`/add-city`)}
                >
                  Add Sitemap
                </button>

              </div> : <></>}
          </div>
        </div>
        {
          pathname == "sitemap" ?

            <div className="row mt-4 mx-auto">
              <div className="sec_border">
                <div className="row">
                  <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                    <div className="whole_searchbar white_bg search_mx_ht">

                      <img
                        className="search_glass"
                        src={require("../assests/images/Search.png")}
                        alt="dummyimg"

                      />
                      <input placeholder="Search term" onChange={(e) => SetSearch(e.target.value)} value={Search} />
                    </div>
                  </div>


                  {Datas && (
                    <div className="ffd_table mar_bot">
                      <BootstrapTable
                        bootstrap4
                        keyField="id"
                        columns={columns_sitemap}
                        data={Datas}
                        pagination={pagination}
                        noDataIndication="No Sitemap found"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            : from ?
              <div className="row mt-4 mx-auto">
                <div className="sec_border">
                  <div className="row">
                    <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                      <div className="whole_searchbar white_bg search_mx_ht">

                        <img
                          className="search_glass"
                          src={require("../assests/images/Search.png")}
                          alt="dummyimg"

                        />
                        <input placeholder="Search term" onChange={(e) => SetSearch(e.target.value)} value={Search} />
                      </div>
                    </div>


                    {Datas && (
                      <div className="ffd_table mar_bot">
                        <BootstrapTable
                          bootstrap4
                          keyField="_id"
                          columns={columns}
                          data={Datas}
                          pagination={pagination1}
                          noDataIndication="No Sitemap found"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              :
              (pathname == "sitemap-add" || pathname == "sitemap-edit") ?
                <div className="sec_border">
                  <Row className="mdv_inputrow">
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-3"
                    >
                      <p className="mdv_inplabel"> From</p>
                      <input
                        className="mdv_cmninput"
                        value={Sitemap.from}
                        type="text"
                        placeholder="Enter From"
                        onChange={(e) => SetSitemap({
                          ...Sitemap, ...{
                            from: e?.target?.value
                          }
                        })}
                      />
                      {ValidateError && ValidateError.from && (
                        <span className="error-msg">
                          {ValidateError?.from}
                        </span>
                      )}
                    </Col>

                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-3"
                    >
                      <p className="mdv_inplabel"> Location</p>
                      <input
                        className="mdv_cmninput"
                        value={Sitemap.url}
                        type="text"
                        placeholder="Enter XML location format"
                        onChange={(e) => SetSitemap({
                          ...Sitemap, ...{
                            url: e?.target?.value
                          }
                        })}
                      />
                      {ValidateError && ValidateError.url && (
                        <span className="error-msg">
                          {ValidateError?.url}
                        </span>
                      )}
                    </Col>



                  </Row>
                  <div className="mdv_update_dualbtn mt-3">
                    <button
                      className="blue_btn mdv_update"
                      onClick={() => { pathname == "sitemap-add" ? _add() : _edit() }}
                    >
                      save
                    </button>
                  </div>
                </div>
                :
                (pathname == "sitemap-add" || pathname == "sitemap-edit") ?
                  <div className="sec_border">
                    <Row className="mdv_inputrow">
                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={6}
                        xs={12}
                        className="mb-3"
                      >
                        <p className="mdv_inplabel"> From</p>
                        <input
                          className="mdv_cmninput"
                          value={Sitemap.from}
                          type="text"
                          placeholder="Enter From"
                          onChange={(e) => SetSitemap({
                            ...Sitemap, ...{
                              from: e?.target?.value
                            }
                          })}
                        />
                        {ValidateError && ValidateError.from && (
                          <span className="error-msg">
                            {ValidateError?.from}
                          </span>
                        )}
                      </Col>

                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={6}
                        xs={12}
                        className="mb-3"
                      >
                        <p className="mdv_inplabel"> Location</p>
                        <input
                          className="mdv_cmninput"
                          value={Sitemap.url}
                          type="text"
                          placeholder="Enter XML location format"
                          onChange={(e) => SetSitemap({
                            ...Sitemap, ...{
                              url: e?.target?.value
                            }
                          })}
                        />
                        {ValidateError && ValidateError.url && (
                          <span className="error-msg">
                            {ValidateError?.url}
                          </span>
                        )}
                      </Col>



                    </Row>
                    <div className="mdv_update_dualbtn mt-3">
                      <button
                        className="blue_btn mdv_update"
                        onClick={() => { pathname == "sitemap-add" ? _add() : _edit() }}
                      >
                        save
                      </button>
                    </div>
                  </div>

                  :
                  <div className="sec_border">
                    <Row className="mdv_inputrow">
                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={6}
                        xs={12}
                        className="mb-3"
                      >
                        <p className="mdv_inplabel"> City Name</p>
                        <input
                          className="mdv_cmninput"
                          value={city}
                          type="text"
                          placeholder="Enter Category Name"
                          onChange={(e) => SetCity(e?.target?.value)}
                        />
                        {ValidateError && ValidateError.City && (
                          <span className="error-msg">
                            {ValidateError.City}
                          </span>
                        )}
                      </Col>




                    </Row>
                    <div className="mdv_update_dualbtn mt-3">
                      <button
                        className="blue_btn mdv_update"
                        onClick={() => { id ? _edit() : _add() }}
                      >
                        save
                      </button>
                    </div>
                  </div>
        }
      </section>
    </>
  );
}

export default Sitemap;
